"use strict";
/* eslint-disable no-underscore-dangle */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ListBlockDefinition = exports.ListBlock = exports.ListBlockValidationError = void 0;
var uuid_1 = require("uuid");
var BaseSequenceBlock_1 = require("./BaseSequenceBlock");
var text_1 = require("../../../utils/text");
/* global $ */
var ListBlockValidationError = /** @class */ (function () {
    function ListBlockValidationError(blockErrors, nonBlockErrors) {
        this.blockErrors = blockErrors;
        this.nonBlockErrors = nonBlockErrors;
    }
    return ListBlockValidationError;
}());
exports.ListBlockValidationError = ListBlockValidationError;
var ListChild = /** @class */ (function (_super) {
    __extends(ListChild, _super);
    function ListChild() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    wrapper for an item inside a ListBlock
    */
    ListChild.prototype.getState = function () {
        return {
            id: this.id,
            value: this.block.getState(),
        };
    };
    ListChild.prototype.getValue = function () {
        return this.block.getValue();
    };
    return ListChild;
}(BaseSequenceBlock_1.BaseSequenceChild));
var InsertPosition = /** @class */ (function (_super) {
    __extends(InsertPosition, _super);
    /*
    Represents a position in the DOM where a new list item can be inserted.
  
    This renders a + button. Later, these could also be used to represent drop zones for drag+drop reordering.
    */
    function InsertPosition(placeholder, opts) {
        var _this = _super.call(this, placeholder, opts) || this;
        _this.onRequestInsert = opts && opts.onRequestInsert;
        var animate = opts && opts.animate;
        var button = $("\n      <button type=\"button\" title=\"" + text_1.escapeHtml(opts.strings.ADD) + "\" data-streamfield-list-add\n          class=\"c-sf-add-button c-sf-add-button--visible\">\n        <i aria-hidden=\"true\">+</i>\n      </button>\n    ");
        $(placeholder).replaceWith(button);
        _this.element = button.get(0);
        button.click(function () {
            if (_this.onRequestInsert) {
                _this.onRequestInsert(_this.index);
            }
        });
        if (animate) {
            button.hide().slideDown();
        }
        return _this;
    }
    InsertPosition.prototype.enable = function () {
        $(this.element).removeAttr('disabled');
    };
    InsertPosition.prototype.disable = function () {
        $(this.element).attr('disabled', 'true');
    };
    return InsertPosition;
}(BaseSequenceBlock_1.BaseInsertionControl));
var ListBlock = /** @class */ (function (_super) {
    __extends(ListBlock, _super);
    function ListBlock(blockDef, placeholder, prefix, initialState, initialError) {
        var _this = this;
        _this.blockDef = blockDef;
        _this.type = blockDef.name;
        _this.prefix = prefix;
        var dom = $("\n      <div class=\"c-sf-container " + text_1.escapeHtml(_this.blockDef.meta.classname || '') + "\">\n        <input type=\"hidden\" name=\"" + text_1.escapeHtml(prefix) + "-count\" data-streamfield-list-count value=\"0\">\n\n        <div data-streamfield-list-container></div>\n      </div>\n    ");
        $(placeholder).replaceWith(dom);
        if (_this.blockDef.meta.helpText) {
            // help text is left unescaped as per Django conventions
            $("\n        <span>\n          <div class=\"help\">\n            " + _this.blockDef.meta.helpIcon + "\n            " + _this.blockDef.meta.helpText + "\n          </div>\n        </span>\n      ").insertBefore(dom);
        }
        _this.children = [];
        _this.inserters = [];
        _this.blockCounter = 0;
        _this.countInput = dom.find('[data-streamfield-list-count]');
        _this.sequenceContainer = dom.find('[data-streamfield-list-container]');
        _this.container = dom;
        _this.setState(initialState || []);
        if (_this.blockDef.meta.collapsed) {
            _this.children.forEach(function (block) {
                block.collapse();
            });
        }
        if (initialError) {
            _this.setError(initialError);
        }
        return _this;
    }
    ListBlock.prototype.setState = function (blocks) {
        var _this = this;
        // State for a ListBlock is a list of {id, value} objects, but
        // ListBlock.insert accepts the value as first argument; id is passed in the options dict instead.
        this.clear();
        blocks.forEach(function (_a, i) {
            var value = _a.value, id = _a.id;
            _this.insert(value, i, { id: id || uuid_1.v4() });
        });
    };
    ListBlock.prototype._getChildDataForInsertion = function () {
        /* Called when an 'insert new block' action is triggered: given a dict of data from the insertion control,
        return the block definition and initial state to be used for the new block.
        For a ListBlock, no data is passed from the insertion control, as there is a single fixed child block definition.
        */
        var blockDef = this.blockDef.childBlockDef;
        var initialState = this.blockDef.initialChildState;
        return [blockDef, initialState];
    };
    ListBlock.prototype._createChild = function (blockDef, placeholder, prefix, index, id, initialState, sequence, opts) {
        return new ListChild(blockDef, placeholder, prefix, index, id, initialState, sequence, opts);
    };
    ListBlock.prototype._createInsertionControl = function (placeholder, opts) {
        return new InsertPosition(placeholder, opts);
    };
    /*
     * Called whenever a block is added or removed
     *
     * Updates the state of add / duplicate block buttons to prevent too many blocks being inserted.
     */
    ListBlock.prototype.blockCountChanged = function () {
        _super.prototype.blockCountChanged.call(this);
        if (typeof this.blockDef.meta.maxNum === 'number') {
            if (this.children.length >= this.blockDef.meta.maxNum) {
                /* prevent adding new blocks */
                for (var i = 0; i < this.inserters.length; i++) {
                    this.inserters[i].disable();
                }
                for (var i = 0; i < this.children.length; i++) {
                    this.children[i].disableDuplication();
                }
            }
            else {
                /* allow adding new blocks */
                for (var i = 0; i < this.inserters.length; i++) {
                    this.inserters[i].enable();
                }
                for (var i = 0; i < this.children.length; i++) {
                    this.children[i].enableDuplication();
                }
            }
        }
    };
    ListBlock.prototype.insert = function (value, index, opts) {
        return this._insert(this.blockDef.childBlockDef, value, opts === null || opts === void 0 ? void 0 : opts.id, index, opts);
    };
    ListBlock.prototype.duplicateBlock = function (index, opts) {
        var child = this.children[index];
        // child.getState() is the state of the ListChild, which is a dict of value and id;
        // for inserting a new child block, we just want the value (and will assign a new id).
        var childState = child.getState().value;
        var animate = opts && opts.animate;
        this.insert(childState, index + 1, { animate: animate, collapsed: child.collapsed });
        this.children[index + 1].focus({ soft: true });
    };
    ListBlock.prototype.setError = function (errorList) {
        var _this = this;
        if (errorList.length !== 1) {
            return;
        }
        var error = errorList[0];
        // Non block errors
        var container = this.container[0];
        container.querySelectorAll(':scope > .help-block.help-critical').forEach(function (element) { return element.remove(); });
        if (error.nonBlockErrors.length > 0) {
            // Add a help block for each error raised
            error.nonBlockErrors.forEach(function (nonBlockError) {
                var errorElement = document.createElement('p');
                errorElement.classList.add('help-block');
                errorElement.classList.add('help-critical');
                errorElement.innerHTML = text_1.escapeHtml(nonBlockError.messages[0]);
                container.insertBefore(errorElement, container.childNodes[0]);
            });
        }
        // error.blockErrors = a list with the same length as the data,
        // with nulls for items without errors
        error.blockErrors.forEach(function (blockError, blockIndex) {
            if (blockError) {
                _this.children[blockIndex].setError(blockError);
            }
        });
    };
    return ListBlock;
}(BaseSequenceBlock_1.BaseSequenceBlock));
exports.ListBlock = ListBlock;
var ListBlockDefinition = /** @class */ (function () {
    function ListBlockDefinition(name, childBlockDef, initialChildState, meta) {
        this.name = name;
        this.childBlockDef = childBlockDef;
        this.initialChildState = initialChildState;
        this.meta = meta;
    }
    ListBlockDefinition.prototype.render = function (placeholder, prefix, initialState, initialError) {
        return new ListBlock(this, placeholder, prefix, initialState, initialError);
    };
    return ListBlockDefinition;
}());
exports.ListBlockDefinition = ListBlockDefinition;
